import React from 'react';
import { Box, CircularProgress, Typography, Fade } from '@mui/material';
import BiotechIcon from '@mui/icons-material/Biotech';

const LoadingScreen = ({ loading }) => {
  // Don't render anything if not loading
  if (!loading) {
    return null;
  }

  return (
    <Fade in={loading} timeout={800}>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          backgroundColor: 'background.paper',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            animation: loading ? 'pulse 1.5s infinite ease-in-out' : 'none',
            '@keyframes pulse': {
              '0%': {
                transform: 'scale(1)',
              },
              '50%': {
                transform: 'scale(1.05)',
              },
              '100%': {
                transform: 'scale(1)',
              },
            },
          }}
        >
          <BiotechIcon
            color="primary"
            sx={{
              fontSize: 60,
              mb: 2,
              animation: loading ? 'rotate 3s infinite linear' : 'none',
              '@keyframes rotate': {
                '0%': {
                  transform: 'rotate(0deg)',
                },
                '100%': {
                  transform: 'rotate(360deg)',
                },
              },
            }}
          />
          <Typography
            variant="h4"
            component="h1"
            color="primary"
            fontWeight="bold"
            gutterBottom
          >
            Neobot
          </Typography>
          <Typography
            variant="subtitle1"
            color="text.secondary"
            align="center"
            sx={{ mb: 3 }}
          >
            Neonatology RAG Assistant
          </Typography>
          <CircularProgress
            size={24}
            thickness={4}
            sx={{
              color: 'secondary.main',
            }}
          />
        </Box>
      </Box>
    </Fade>
  );
};

export default LoadingScreen;
